export const FROM_MOBILE_APP_FLAG = "fromMobileApp";
export const MOBILE_TOKEN_FLAG = "mobileToken";
export const SHOULD_REDIRECT_TO_MOBILE_FLAG = "shouldRedirectToMobile";
export const WEB_APP_COMPONENT_FLAG = "webAppComponent";
export const MOBILE_RETURN_TO_ON_ERR_FLAG = "returnToOnError";
export const SHARE_KEY_PREVIEW_PARAM = "skpreview";
export const TRACKSTORY_QUERY_PARAM = "ts";
export const TRACKSTORY_AUTO_START_PARAM = "tsautostart";

const root = "";

export const routePaths = {
  root: `${root}/`,
  download: `${root}/download/:requestId`,
  spaceRoot: `${root}/space`,
  createSpace: `${root}/create-space`,
  spaceHome: `${root}/space/:spaceId`,
  spaceHandoff: `${root}/space-handoff`,
  space: `${root}/space/:spaceId?/:trackId?/:trackVersionId?`,
  spaceTrack: `${root}/space/:spaceId/:trackId`,
  home: `${root}/home`,
  library: `${root}/library`,

  settings: `${root}/settings/:settingsTabId?`,
  checkout: `${root}/checkout`,

  startLoopSubmission: `${root}/start-loop-submission`,

  completeLoopSubmission: `${root}/complete-loop-submission`,

  login: `${root}/login`,
  signup: `${root}/signup`,
  link: `${root}/link`,
  logout: `${root}/logout`,

  plans: `${root}/plans`,
  usage: `${root}/settings/usage`,

  trackstories: `${root}/trackstories`,

  track: `${root}/track/:trackId`,

  share: `${root}/share/:feedbackRequestId`,
  test: `${root}/test`,

  collectionRoot: `${root}/collection`,
  collectionHome: `${root}/collection/:collectionId`,

  dropboxLogin: `${root}/dropbox/login`,
  dropboxCallback: `${root}/dropbox/callback`,
  dropboxClone: `${root}/dropbox/clone`,

  submit: `${root}/submit`,

  mobileLoginRedirect: `${root}/mobile-login-redirect`,
};

export const withMobileDeeplinkRoot = (path: string, shareKey?: string) => {
  const root =
    window.location.origin === "https://on.highnote.fm"
      ? `highnote`
      : `highnote-dev`;
  if (!shareKey) {
    return `${root}://${path}`;
  }
  // Carry the current session's shareKey across the web-to-app bridge so a
  // signed-in visitor arriving via a share link isn't dropped into the app
  // keyless (mobile's checkProtectedEntity call would then 400/space-not-found).
  const separator = path.includes("?") ? "&" : "?";
  return `${root}://${path}${separator}shareKey=${encodeURIComponent(shareKey)}`;
};

export const withMobileAuthDeeplinkRoot = (path: string) => {
  const root =
    window.location.origin === "https://on.highnote.fm"
      ? `highnote-auth`
      : `highnote-dev-auth`;
  return `${root}://${path}`;
};

export const sanitizeCurrentURL = (keysToRemove: string[]) => {
  const searchParams = new URLSearchParams(window.location.search);
  keysToRemove.forEach((key) => {
    searchParams.delete(key);
  });
  return `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
};
